import { AddToCartResponse, PostShoppingCartCheckout, PostShoppingCartItem, ShoppingCart, ShoppingCartItem } from '@ravago/shared/page-data/models/features';

export class ShoppingCartUtils {
  static async getShoppingCart(): Promise<ShoppingCart> {
    const response = await fetch(`/api/customers/shopping-cart`);
    const emptyCart: ShoppingCart = {
      items: [],
      numberOfItems: 0,
      problems: [],
      deliveryAddressId: undefined
    };
    if (response.ok) {
      return response.json();
    }
    return emptyCart;
  }

  static async addToShoppingCart(item: PostShoppingCartItem): Promise<AddToCartResponse> {
    const response = await fetch(`/api/customers/shopping-cart`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(item)
    });
    if (response.ok) {
      return response.json();
    }
    return { success: false, problems: [] };
  }

  static async checkout(request: PostShoppingCartCheckout): Promise<string> {
    const response = await fetch(`/api/customers/checkout`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(request)
    });
    if (response.ok) {
      return response.json();
    }
    return '';
  }

  static async removeFromShoppingCart(id: ShoppingCartItem['id']): Promise<boolean> {
    const response = await fetch(`/api/customers/shopping-cart/${id}`, {
      method: 'DELETE'
    });

    if (response.ok) {
      return response.json();
    }
    return false;
  }
}
